export default __webpack_public_path__ + "static/media/slide-5.6a0464a1.gif";